import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/comic";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.06)]"
          : "bg-transparent"
      }`}
    >
      <nav
        className={`mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 transition-colors ${
          scrolled ? "py-3" : "py-5"
        }`}
        aria-label="主导航"
      >
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg text-lg font-bold ${
              scrolled
                ? "bg-primary-500 text-background-50"
                : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className="ri-book-open-line"></i>
          </span>
          <span
            className={`font-heading text-2xl tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            静漫天堂
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  : "text-background-50/90 hover:bg-background-50/15 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#quality"
            className="rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            开始浏览
          </a>
          <button
            type="button"
            aria-label="打开搜索"
            className={`flex h-10 w-10 items-center justify-center rounded-full text-lg transition-colors ${
              scrolled
                ? "text-foreground-700 hover:bg-background-100"
                : "text-background-50/90 hover:bg-background-50/15"
            }`}
          >
            <i className="ri-search-line"></i>
          </button>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-lg text-xl md:hidden ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 px-4 py-4 backdrop-blur-md md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-4 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#quality"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-5 py-3 text-center text-sm font-medium whitespace-nowrap text-background-50"
            >
              开始浏览
            </a>
          </div>
        </div>
      )}
    </header>
  );
}